var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, ToggleButton, ToggleButtonGroup, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
var StyledIcon = styled(FontAwesomeIcon)(function (_a) {
  var theme = _a.theme;
  return {
    color: theme.palette.primary.main,
    '& path': {
      fill: theme.palette.primary.main,
      opacity: '1 !important'
    }
  };
});
var StyledToggleButtonGroup = styled(ToggleButtonGroup)(function (_a) {
  var theme = _a.theme;
  return {
    gap: '1rem',
    '& .MuiButtonBase-root': {
      backgroundColor: theme.palette.common.white,
      border: '0.0625rem solid !important',
      borderRadius: '0.25rem !important',
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      height: '2.625rem',
      '& .MuiTypography-root': {
        fontWeight: 'normal',
        fontSize: theme.typography.pxToRem(14)
      }
    },
    '& .Mui-selected': {
      backgroundColor: theme.palette.primary.light + '!important',
      '&.MuiButtonBase-root': {
        borderWidth: '0.125rem !important'
      },
      '& .MuiTypography-root': {
        textShadow: '0.044rem 0 0 ' + theme.palette.common.black
      }
    }
  };
});
export var ControlPanelSetting = function (_a) {
  var value = _a.value,
    options = _a.options,
    onChange = _a.onChange;
  var t = useTranslation('report', {
    keyPrefix: 'actual.section'
  }).t;
  return _jsx(Stack, __assign({
    direction: "row",
    alignItems: "center",
    spacing: "1rem"
  }, {
    children: _jsx(StyledToggleButtonGroup, __assign({
      color: "primary",
      value: value,
      exclusive: true,
      onChange: function (e, newValue) {
        return newValue && onChange(newValue);
      }
    }, {
      children: options.map(function (button) {
        var _a;
        return _jsxs(ToggleButton, __assign({
          value: button.value,
          sx: {
            gap: '0.5rem',
            minWidth: ((_a = button.style) === null || _a === void 0 ? void 0 : _a.minWidth) || 'auto'
          }
        }, {
          children: [_jsx(StyledIcon, {
            icon: button.icon,
            size: "lg"
          }), _jsx(Typography, __assign({
            component: "span"
          }, {
            children: t(button.value)
          }))]
        }), button.value);
      })
    }))
  }));
};